'use strict';

var baseUtils = require('org/util/utils');
var _ = require('lodash');

var utils = $.extend({}, baseUtils, {
    /**
     * @function
     * @desc Syncs the heights of all elements passed
     * @param {jQuery} $elements - elements to sync
     */
    syncHeights: function ($elements) {
        // clear any inline height styles
        _.each($elements, function (el) {
            $(el).css('height', '');
        });
        var $tallestEl = _.maxBy($elements, function (el) { return $(el).height(); });
        _.each($elements, function (el) {
            $(el).css('height', $tallestEl.offsetHeight);
        });
    },

    /**
     * @function
     * @description Executes a callback function when the user has stopped resizing the screen.
     * It will only execute on changes to page width.
     * @param {function} callback - Callback function for the resize event
     */
    smartResize: function (callback) {
        var windowWidth = $(window).innerWidth();

        $(window).resize(_.debounce(function () {
            if (windowWidth !== $(window).innerWidth()) {
                callback();
                windowWidth = $(window).innerWidth();
            }
        }, 100));
    },

    /**
     * mutationObserver - Einstein Observer
     * Initialize an observer for adding a callback to Einstein DOM element injection.
     * @param {jQuery} $elements - jQuery element(s) to observe for changes
     * @param {function} fn - the callback for when changes are found
     */
    mutationObserver: function ($elements, fn) {
        var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
        var einsteinSelector = '[id^="cq_recomm_slot"]';
        var check = function (mutationList, observer) {
            if (mutationList.length) {
                // if new child detected, disconnect observer and call callback
                observer.disconnect();
                fn.call();
            }
        };

        // check each element for child
        $elements.each(function (index, element) {
            var einsteinElement = element.querySelector(einsteinSelector);
            if (einsteinElement === null) {
                // not an einstein recommender slot
                if (element.childElementCount > 0) {
                    // if child, call callback immediately
                    fn.call();
                } // TO DO: THERE'S NO CONDITION HERE TO HANDLE NON-EINSTEIN ELEMENTS WHERE CHILD ELEMENTS ARE INSERTED AFTER A DELAY
            } else if (einsteinElement.childElementCount > 0) {
                // if child, call callback immediately
                fn.call();
            } else {
                // if no child, attach observer and wait for child to be added
                var observer = new MutationObserver(check);
                observer.observe(einsteinElement, { childList: true });
            }
        });
    },

    /**
     * affirmObserver - Affirm Observer
     * Initialize an observer for adding a callback to Affirm DOM element injection.
     * @param {jQuery} $elements - jQuery element(s) to observe for changes
     * @param {function} fn - the callback for when changes are found
     */
    affirmObserver: function ($elements, fn) {
        // eslint-disable-next-line require-jsdoc
        function affirmMutations(mutations, observer) {
            for (let mutation of mutations) {
                if (mutation.target.classList.contains('affirm-as-low-as')) observer.disconnect();
                fn.call();
            }
        }
        $elements.each(function (index, element) {
            var observer = new MutationObserver(affirmMutations);
            observer.observe(element, { characterData: true, subtree: true, childList: true });
        });
    },

    /**
    * @function
    * @description adds values to resource strings
    * @returns {string} s - the string
    * Taken from SiteGenesis
    */
    stringFormat: function () {
        var s = arguments[0];
        var i;
        var len = arguments.length - 1;
        for (i = 0; i < len; i++) {
            var reg = new RegExp('\\{' + i + '\\}', 'gm');
            s = s.replace(reg, arguments[i + 1]);
        }
        return s;
    },

    /**
    * Checks if an element is in viewport
    * https://stackoverflow.com/a/26831113
    * @param {jQuery} $el - the target element
    * @returns {boolean} - if the element in viewport
    */
    isInViewport: function ($el) {
        var elHeight = $el.outerHeight();
        var windowHeight = $(window).height();
        var relativeSize = $el[0].getBoundingClientRect();
        var top = relativeSize.top;
        var bottom = relativeSize.bottom;

        var pxInViewport = Math.max(0, (top > 0) ? Math.min(elHeight, windowHeight - top) :
            Math.min(bottom, windowHeight));

        return (pxInViewport > 0);
    },

    /**
    * IE11 fallback for object-fit CSS usage
    */
    ieObjectFitFix: function () {
        /**
        * Get the browser
        * @return {boolean} browser check
        */
        function msieversion() {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf('MSIE ');

            // If Internet Explorer, return version number
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
                return true;
            }
            return false;
        }

        if (msieversion()) {
            $('.article-feature-card').addClass('object-fit-fix');
            $('.photo-tile-figure').addClass('object-fit-fix');
            $('.video-component').addClass('object-fit-fix');
        }
    }
});

module.exports = utils;
